unit ResultSetRequestType;

interface

type
  TResultSetRequestType = class
  private
    resultSetKey: String;
    pageLength: Word;
    page: Word;
  public
    constructor Create(const String_ResultSetKey: String; const Word_PageLength: Word; const Word_Page: Word);
  end;

implementation

constructor TResultSetRequestType.Create(const String_ResultSetKey: String; const Word_PageLength: Word; const Word_Page: Word);
begin
  resultSetKey := String_ResultSetKey;
  pageLength := Word_PageLength;
  page := Word_Page;
end;

end.
